export const selectEntryChannels = (state) => state.entryChannels.entryChannels;

export const selectEntryChannelsLoading = (state) => state.entryChannels.loading;

export const selectEntryChannelsPag = (state) => state.entryChannels.entryChannelsPag;

export const selectEntryChannelsLoadingPag = (state) => state.entryChannels.loadingPag;